// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".datetime .dropdown-content {\n  width: 25%;\n}\n.datetime .dropdown-content .field-body .field {\n    flex-direction: row-reverse;\n}\n.changed__text_container {\n  margin-bottom: 15px;\n  font-weight: bold;\n  max-height: 209px;\n  width: 361px;\n  word-wrap: break-word;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
